import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import clsx from 'clsx';
import SubDropdownItem from '@/components/molecules/SubDropdownItem';
import { ContentRelationshipBannerFieldExtended, ContentRelationshipHeaderCategoryFieldExtended, ContentRelationshipItemLinkFieldExtended } from '@/prismicCustomTypes';
import { HeaderItemDocumentData, Simplify } from '@/prismicio-types';
import ArrowRight from '@/public/assets/svg/arrow-right.svg';
const DropdownItem = t0 => {
  const $ = _c(26);
  const {
    item,
    openTab,
    prevTab,
    hideMenu,
    onMouseEnter,
    onMouseLeave
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = item || {};
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    categories
  } = t1;
  const banner = item?.item_banner as ContentRelationshipBannerFieldExtended | undefined;
  const t2 = openTab > -1 ? openTab : prevTab;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      order: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = openTab > -1 ? "max-h-[99999px]" : "max-h-0";
  let t5;
  if ($[4] !== t4) {
    t5 = clsx(t4, "-z-10 w-full xl:transition-[max-height] xl:duration-300");
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = openTab > -1 ? "translate-y-0 overflow-hidden opacity-100" : "pointer-events-none -translate-y-full opacity-0";
  let t7;
  if ($[6] !== t6) {
    t7 = clsx("xl:shadow-elevation-4 pointer-events-auto w-full grid-cols-2 bg-gray-50 xl:grid xl:rounded-[0.625rem] xl:border xl:border-gray-200 xl:bg-white", "xl:transition-accordion z-0 origin-top xl:duration-200 xl:ease-in", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== categories || $[9] !== hideMenu) {
    t8 = categories?.map((item_0, index) => {
      const {
        data
      } = item_0.item as ContentRelationshipHeaderCategoryFieldExtended;
      return <div key={data?.name ?? index} className="pt-[22px] first:pt-0 xl:pt-0"><span className="text-caption-3 font-bold text-gray-500">{data?.name}</span>{!!data?.items?.length && <SubDropdownItem hideMenu={hideMenu} grid={categories?.map(_temp)?.length < 2} items={data.items.map(_temp2) as ContentRelationshipItemLinkFieldExtended[]} />}</div>;
    });
    $[8] = categories;
    $[9] = hideMenu;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <div className="px-6 py-4 xl:px-8 xl:py-8"><div className="w-full gap-x-8 xl:flex">{t8}</div></div>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== banner || $[14] !== hideMenu) {
    t10 = banner && <div className="bg-gray-50 px-6 py-0 xl:px-8 xl:py-8"><h3 className="text-caption-3 mb-4 font-bold text-gray-500 uppercase">{banner.data?.title}</h3><div className="flex flex-col gap-6 xl:flex-row"><PrismicNextImage fallbackAlt="" className="w-full max-w-54 rounded-lg object-contain object-top xl:w-auto" field={banner.data?.image} /><div className="flex flex-col justify-between py-2"><div><h4 className="mb-2 font-semibold text-gray-600">{banner.data?.header}</h4><p className="text-h10 text-gray-500">{banner.data?.copy}</p></div><PrismicNextLink className="text-button flex items-center text-gray-600 hover:opacity-50" field={banner.data?.button_link} onClick={hideMenu}>{banner.data?.button_text}<ArrowRight className="h-6 w-6" /></PrismicNextLink></div></div></div>;
    $[13] = banner;
    $[14] = hideMenu;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7 || $[18] !== t9) {
    t11 = <div className="pointer-events-none top-20 left-0 w-full overflow-hidden xl:absolute"><div className={t7}>{t9}{t10}</div></div>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== onMouseEnter || $[21] !== onMouseLeave || $[22] !== t11 || $[23] !== t3 || $[24] !== t5) {
    t12 = <div style={t3} className={t5} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} data-sentry-component="DropdownItem" data-sentry-source-file="index.tsx">{t11}</div>;
    $[20] = onMouseEnter;
    $[21] = onMouseLeave;
    $[22] = t11;
    $[23] = t3;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default DropdownItem;
function _temp(item_1) {
  return item_1.item;
}
function _temp2(item_2) {
  return item_2.item;
}